import { render, staticRenderFns } from "./PendingView.vue?vue&type=template&id=7928002c"
import script from "./PendingView.vue?vue&type=script&lang=js"
export * from "./PendingView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports